<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { speciesById } from '@/lib/species'

const props = defineProps<{ speciesId: string; seconds?: number }>()
const emit = defineEmits<{ caught: []; gone: [] }>()

const art = computed(() => speciesById(props.speciesId))

// prefers-reduced-motion haandhaeves globalt i main.css og saetter alle animationer til 0,001 ms.
// Uden hensyn hertil ville dyret krydse skaermen usynligt for netop de brugere. I stedet staar det
// stille et par sekunder — man skal ikke laases ude af en samling af en tilgaengelighedsindstilling.
const stille = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
const synlig = ref(false)

onMounted(() => {
  synlig.value = true
  const ms = (props.seconds ?? (stille ? 4 : 2.4)) * 1000
  setTimeout(() => {
    synlig.value = false
    emit('gone')
  }, ms)
})

function fang() {
  synlig.value = false
  emit('caught')
}
</script>

<template>
  <button
    v-if="synlig && art"
    class="creature"
    :class="{ still: stille }"
    type="button"
    :aria-label="$t('discovery.creatureLabel')"
    @click="fang"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path v-for="(d, i) in art.paths" :key="i" :d="d" />
    </svg>
  </button>
</template>

<style scoped>
/* Silhuet, ikke ikon: den skal kunne overses. */
.creature {
  position: fixed;
  top: 38%;
  left: 0;
  z-index: 60;
  width: clamp(3rem, 12vw, 5.5rem);
  height: clamp(3rem, 12vw, 5.5rem);
  padding: 0;
  border: 0;
  background: none;
  color: color-mix(in srgb, var(--text) 22%, transparent);
  cursor: pointer;
  animation: svoem 2.4s linear;
}
.creature svg { width: 100%; height: 100%; }
.creature:hover { color: color-mix(in srgb, var(--accent) 55%, transparent); }

/* Reduceret bevaegelse: staa stille i kanten i stedet for at glide forbi. */
.creature.still {
  left: auto;
  right: 5vw;
  animation: none;
  opacity: 0.5;
}

@keyframes svoem {
  from { transform: translateX(-20vw) scaleX(1); }
  to { transform: translateX(115vw) scaleX(1); }
}
</style>
